import { API_URL } from '../config'

/**
 * Utility functions for the CryptoQuant component
 */

/**
 * Fetches BTC sentiments data from the backend API
 * @returns Promise with the data or throws an error
 */
const fetchSheetData = async (sheetName: string) => {
  const response = await fetch(`${API_URL}/sheets/read?sheet=${sheetName}&range=A1:Z1000`)

  if (!response.ok) {
    let errorText = 'No response text'
    try {
      const errorJson = await response.json()
      console.log('Error response JSON:', errorJson)
      errorText = JSON.stringify(errorJson)
    } catch (jsonError) {
      errorText = await response.text().catch(() => 'Failed to get response text')
      console.log('Error response text:', errorText)
    }
    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`)
  }

  const result = await response.json()

  if (!result.data || !Array.isArray(result.data)) {
    throw new Error('Invalid data format received from API')
  }

  // Filter out empty rows
  const filteredData = result.data.filter((row: unknown[]) =>
    Array.isArray(row) && row.some(cell => cell !== null && cell !== '')
  )
  return filteredData
}

export const fetchBtcSentimentsData = () => fetchSheetData('cryptoquant_btc_sentiments')

export const fetchDetailedBtcSentimentsData = () => fetchSheetData('cryptoquant_btc_detailed_sentiments')
